export const user = {
    USER_NOT_FOUND: "CPF não encontrado em nosso cadastro. Favor preencha seus dados para seguir com o agendamento"
}
